import { render, staticRenderFns } from "./AddBannerButton.vue?vue&type=template&id=b92ad51c&scoped=true&"
import script from "./AddBannerButton.vue?vue&type=script&lang=js&"
export * from "./AddBannerButton.vue?vue&type=script&lang=js&"
import style0 from "./AddBannerButton.vue?vue&type=style&index=0&id=b92ad51c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92ad51c",
  null
  
)

export default component.exports